module.exports = __webpack_public_path__ + "img/solution_bg1.480e7a9.webp";